import React from 'react';
import { DESC, List } from 'framework/list';
import useInvoiceService from 'domain/finance/invoice/useInvoiceService';
import { SensitiveListElementLayout } from 'framework/sensitiveData';
import { useInvoiceUrl } from 'domain/finance/invoice/shared/useInvoiceRouting';
import InvoiceListPageContent from 'domain/finance/invoice/List/InvoiceListPageContent';

const InvoiceListPage = () => {
  const { search, getSensitiveDataByIds } = useInvoiceService();
  const { getListUrl } = useInvoiceUrl();

  return (
    <List getDataMethod={search} defaultSortField="invoiceDate" defaultSortOrder={DESC} defaultFilter={{}}>
      <SensitiveListElementLayout
        sensitiveDataIdSource="id"
        loadSensitiveDataMethod={getSensitiveDataByIds}
        timerId={getListUrl()}
      >
        <InvoiceListPageContent />
      </SensitiveListElementLayout>
    </List>
  );
};

export default InvoiceListPage;
